import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  applicantCount: {
    id: `app.containers.WorkflowEditor.components.WorkflowNavBar.applicantCount`,
    defaultMessage: '{applicantCount} applicants',
  },
  workflowEditorNavigation: {
    id: `app.containers.WorkflowEditor.components.WorkflowNavBar.workflowEditorNavigation`,
    defaultMessage: 'Workflow Funnel Editor Navigation',
  },
  workflowEditorOpeningSelector: {
    id: `app.containers.WorkflowEditor.components.WorkflowNavBar.workflowEditorOpeningSelector`,
    defaultMessage: 'Opening Selector',
  },
  workflowTitle: {
    id: `app.containers.WorkflowEditor.components.WorkflowNavBar.workflowTitle`,
    defaultMessage: 'Workflow Title',
  },
  newWorkflowName: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.newWorkflowName',
    defaultMessage: 'Please enter a new name for this workflow',
  },
  renameWorkflowMenu: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.renameWorkflowMenu',
    defaultMessage: 'Edit Workflow Details',
  },
  renameWorkflow: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.renameWorkflow',
    defaultMessage: 'Edit Workflow Details',
  },
  editWorkflowDescription: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.editWorkflowDescription',
    defaultMessage: 'Update the workflow name and description',
  },
  renameLabel: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.renameLabel',
    defaultMessage: 'Name',
  },
  descriptionLabel: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.descriptionLabel',
    defaultMessage: 'Description',
  },
  descriptionHelperText: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.descriptionHelperText',
    defaultMessage: '{count}/500 characters',
  },
  renameSuccess: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.renameSuccess',
    defaultMessage: 'Workflow updated successfully',
  },
  associatedOpenings: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.associatedOpenings',
    defaultMessage: '{count} associated openings',
  },
  associatedOpening: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.associatedOpening',
    defaultMessage: '{count} associated opening',
  },
  applicants: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.applicants',
    defaultMessage: '{count} Applicants',
  },
  applicant: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.applicant',
    defaultMessage: '{count} Applicant',
  },
  search: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.search',
    defaultMessage: 'Search',
  },
  visualizeWorkflowInCue: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.visualizeWorkflowInCue',
    defaultMessage: 'Visualize workflow in Cue',
    description:
      'Menu item on the workflow editor navigation bar that opens Cue to render this workflow as a diagram',
  },
  visualizeWorkflowPrompt: {
    id: 'app.containers.WorkfloWEditor.components.WorkflowNavBar.visualizeWorkflowPrompt',
    defaultMessage: 'Show this workflow as a diagram',
    description:
      'Prompt sent to Cue when the recruiter picks Visualize workflow in Cue from the workflow editor',
  },
});
